const removeSplashScreen = () => {
  setTimeout(() => {
    document.documentElement.classList.remove('splash-screen--active');
    Cookies.set('splash_screen_seen', 'yes', { expires: 1 });
    if (landingSlider) {
      // Start Landing Swiper autoplay
      landingSlider.autoplay.start();
    }
  }, 2000);
};

window.addEventListener('load', () => {
  if (Cookies.get('splash_screen_seen') !== 'yes') {
    document.documentElement.classList.add('splash-screen--active');
    // Stop Landing Swiper autoplay
    if (landingSlider) {
      landingSlider.autoplay.stop();
    }
    removeSplashScreen();
  } else {
    document.documentElement.classList.remove('splash-screen--active');
  }
});
